export default function CompletionModal({
  level = 1,
  has14DayStreakBadge = false,
  badgesLoading = false,
  onRestartLevel1,
  onPlayLevel2,
  onPlayLevel3,
  onViewBadges,
  onExit,
}: {
  level?: number;
  has14DayStreakBadge?: boolean;
  badgesLoading?: boolean;
  onRestartLevel1?: () => void;
  onPlayLevel2?: () => void;
  onPlayLevel3?: () => void;
  onViewBadges?: () => void;
  onExit?: () => void;
}) {
  // debugMode removed - completion UI no longer shows debug badge check

  const handleRestart = () => {
    onRestartLevel1?.();
  };

  const handlePlayLevel2 = () => {
    onPlayLevel2?.();
  };

  const handleViewBadges = () => {
    onViewBadges?.();
  };

  const handlePlayLevel3 = () => {
    onPlayLevel3?.();
  };

  const handleExit = () => {
    if (onExit) {
      onExit();
      return;
    }
    try {
      window.history.back();
    } catch (e) {
      void e;
    }
  };

  return (
    <div className="pointer-events-auto fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 py-8 transition-opacity duration-300">
      <div className="w-full max-w-md rounded-2xl bg-white/10 p-6 text-center shadow-2xl ring-1 ring-white/10 backdrop-blur-lg">
        <h2 className="text-center text-3xl font-semibold text-white">
          SESSION COMPLETE
        </h2>

        {level === 1 ? (
          has14DayStreakBadge ? (
            <>
              <p className="mt-4 text-center text-base leading-relaxed text-white/80">
                <span className="block">🎉 Level 2 Unlocked</span>
                <span className="mt-3 block">
                  You’ve earned the 14-Day Streak Badge.
                  <br />
                  You can now play Level 2.
                </span>
              </p>

              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <button
                  type="button"
                  onClick={handlePlayLevel2}
                  className="min-h-[56px] w-full flex-1 rounded-xl bg-gradient-to-r from-amber-400/90 to-orange-400/90 px-6 py-3 text-lg font-semibold uppercase tracking-wide text-white shadow-lg transition-transform duration-200 hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-amber-300/60 disabled:cursor-not-allowed disabled:opacity-60"
                  disabled={badgesLoading}
                >
                  PLAY LEVEL 2
                </button>
                <button
                  type="button"
                  onClick={handleRestart}
                  className="min-h-[56px] w-full rounded-xl bg-white/10 px-4 py-3 text-lg font-semibold uppercase tracking-wide text-white/80 shadow-md transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/30 sm:w-[180px]"
                >
                  REPLAY LEVEL 1
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="mt-4 text-center text-base leading-relaxed text-white/80">
                <span className="block">You’ve completed Level 1.</span>
                <span className="mt-3 block">
                  To unlock Level 2, you need to earn the{' '}
                  <strong className="font-semibold text-white">
                    14-Day Streak Badge
                  </strong>{' '}
                  by practicing daily breathing.
                </span>
              </p>

              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <button
                  type="button"
                  onClick={handleViewBadges}
                  className="min-h-[56px] w-full flex-1 rounded-xl bg-gradient-to-r from-amber-400/90 to-orange-400/90 px-6 py-3 text-lg font-semibold uppercase tracking-wide text-white shadow-lg transition-transform duration-200 hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-amber-300/60"
                >
                  VIEW BADGES
                </button>
                <button
                  type="button"
                  onClick={handleRestart}
                  className="min-h-[56px] w-full rounded-xl bg-white/10 px-4 py-3 text-lg font-semibold uppercase tracking-wide text-white/80 shadow-md transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/30 sm:w-[180px]"
                >
                  RESTART LEVEL 1
                </button>
              </div>
            </>
          )
        ) : (
          <>
            <p className="mt-4 text-center text-base leading-relaxed text-white/80">
              Your breathing helped guide the Buddha upward with calm and
              control.
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              {level === 2 && onPlayLevel3 && (
                <button
                  type="button"
                  onClick={handlePlayLevel3}
                  className="min-h-[56px] w-full flex-1 rounded-xl bg-gradient-to-r from-amber-400/90 to-orange-400/90 px-6 py-3 text-lg font-semibold uppercase tracking-wide text-white shadow-lg transition-transform duration-200 hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-amber-300/60"
                >
                  PLAY LEVEL 3
                </button>
              )}
              <button
                type="button"
                onClick={handleRestart}
                className="min-h-[56px] w-full flex-1 rounded-xl bg-gradient-to-r from-amber-400/90 to-orange-400/90 px-6 py-3 text-lg font-semibold uppercase tracking-wide text-white shadow-lg transition-transform duration-200 hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-amber-300/60"
              >
                RESTART LEVEL 1
              </button>
              <button
                type="button"
                onClick={handleViewBadges}
                className="min-h-[56px] w-full rounded-xl bg-white/10 px-4 py-3 text-lg font-semibold uppercase tracking-wide text-white/80 shadow-md transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/30 sm:w-[180px]"
              >
                VIEW BADGES
              </button>
            </div>
          </>
        )}

        {/* Badge check removed from UI */}

        <button
          type="button"
          onClick={handleExit}
          className="mt-4 text-sm font-semibold text-white/70 underline-offset-4 hover:text-white/90 hover:underline"
        >
          Exit
        </button>
      </div>
    </div>
  );
}
